import { render, staticRenderFns } from "./ModalAddCarrinhoClonePizza.vue?vue&type=template&id=705aedc2&scoped=true"
import script from "./ModalAddCarrinhoClonePizza.vue?vue&type=script&lang=js"
export * from "./ModalAddCarrinhoClonePizza.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCarrinhoClonePizza.vue?vue&type=style&index=0&id=705aedc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705aedc2",
  null
  
)

export default component.exports